<template>
  <div>
    <table-widget
      :items="contacts"
      :perPage="perPage"
      :totalRows="contacts.length"
      :current-page.sync="currentPage"
      :filter.sync="filter"
    >
      <template slot="buttons">
        <b-button
          v-if="manage"
          class="mx-2"
          variant="primary"
          v-b-modal.contact-modal
          @click="selectedContact = null"
          ><font-awesome-icon icon="plus" /> Add contact</b-button
        >
      </template>
      <template slot="content">
        <b-table
          striped
          :items="contacts"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
          @filtered="onFiltered"
          small
          show-empty
          empty-filtered-text="There are no contacts that match your search criteria."
        >
          <template v-slot:cell(name)="data">
            {{ data.item.firstName }} {{ data.item.lastName }}
          </template>
          <template v-slot:cell(email)="data">
            <a :href="'mailto:' + data.item.email">{{ data.item.email }}</a>
          </template>
          <template v-slot:cell(type)="data">
            {{ data.item.contactType ? data.item.contactType.name : "" }}
          </template>
          <template v-slot:cell(details)="data">
            <router-link :to="{ name: 'contact', params: { id: data.item.id } }"
              >Details</router-link
            >
          </template>
          <template v-slot:cell(edit)="data">
            <a @click="editContact(data.item, $event)" href="">Edit</a>
          </template>
        </b-table>
      </template>
    </table-widget>

    <b-modal
      id="contact-modal"
      title="Add Contact"
      v-model="showContactForm"
      hide-footer
    >
      <contact-form
        @cancel="showContactForm = false"
        @save="saveContact"
        @edit="saveContactEdit"
        :awardOptions="awardOptions"
        :contactTypeOptions="contactTypeOptions"
        :communityPartnerOptions="communityPartnerOptions"
        :steps="requiredFormSteps"
        :contact="selectedContact"
      ></contact-form>
    </b-modal>
  </div>
</template>

<script>
import TableWidget from "../table-widget";
import ContactForm from "./contact-form";
import roles from "../../misc/roles";

export default {
  data() {
    return {
      fields: [
        { key: "name" },
        { key: "title" },
        { key: "phoneNumber" },
        { key: "email" },
        { key: "type" },
        { key: "details", label: "" },
        { key: "edit", label: "" },
      ],
      currentPage: 1,
      perPage: 20,
      filter: null,
      totalRows: 0,
      showContactForm: false,
      selectedContact: null,
    };
  },

  props: {
    contacts: {
      type: Array,
      required: true,
      default: function () {
        return [];
      },
    },

    manage: {
      type: Boolean,
      required: false,
      default: function () {
        return false;
      },
    },

    awardOptions: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },

    contactTypeOptions: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },

    communityPartnerOptions: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },

    parentType: {
      type: String,
      required: false,
      default: "communityPartner",
    },
  },

  components: {
    "table-widget": TableWidget,
    "contact-form": ContactForm,
  },

  computed: {
    // returns a list of which optional parts of the contact form need to be shown
    requiredFormSteps: function () {
      var steps = ["main"];

      if (this.parentType === "communityPartner") {
        steps.push("awards");
      }
      if (this.parentType === "award") {
        steps.push("communityPartner");
      }
      if (this.parentType === "project") {
        steps.push("communityPartner");
      }

      if (this.parentType === "proposal") {
        steps.push("communityPartner");
      }
      return steps;
    },
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    saveContact(contact) {
      this.$emit("saveContact", contact);
      this.showContactForm = false;
    },

    saveContactEdit(contact) {
      this.$emit("saveContactEdit", contact);
      this.showContactForm = false;
    },

    editContact(contact, event) {
      event.preventDefault();
      this.selectedContact = contact;
      this.showContactForm = true;
    },
  },
};
</script>

<style scoped>
table {
  font-size: 10pt;
}
</style>
